/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Workflow Service API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DecideWorkflowRecoveryAuthorityBody,
  GetWorkflowRunCompensationScopesParams,
  GetWorkflowRunRecoveryParams,
  ListWorkflowRuns200,
  ListWorkflowRunsParams,
  SubmitWorkflowRunRecoveryCommandBody,
  WorkflowRunActionLogResponse,
  WorkflowRunCompensationScopesResponse,
  WorkflowRunRecoveryResponse,
  WorkflowRunScopedCompensationCommandRequest,
  WorkflowRunScopedCompensationCommandResponse,
  WorkflowRunStatusResponse,
  WorkflowRunSubmissionRequest,
  WorkflowRunSubmitResponse,
} from "../model";

import { customFetch } from "../../../custom-fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type decideWorkflowRecoveryAuthorityResponse200 = {
  data: void;
  status: 200;
};

export type decideWorkflowRecoveryAuthorityResponse403 = {
  data: void;
  status: 403;
};

export type decideWorkflowRecoveryAuthorityResponse503 = {
  data: void;
  status: 503;
};

export type decideWorkflowRecoveryAuthorityResponseSuccess =
  decideWorkflowRecoveryAuthorityResponse200 & {
    headers: Headers;
  };
export type decideWorkflowRecoveryAuthorityResponseError = (
  | decideWorkflowRecoveryAuthorityResponse403
  | decideWorkflowRecoveryAuthorityResponse503
) & {
  headers: Headers;
};

export type decideWorkflowRecoveryAuthorityResponse =
  | decideWorkflowRecoveryAuthorityResponseSuccess
  | decideWorkflowRecoveryAuthorityResponseError;

export const getDecideWorkflowRecoveryAuthorityUrl = () => {
  return `/workflow-service/v1/recovery-authority/decisions`;
};

/**
 * @summary Decide live recovery authority for a receiver command
 */
export const decideWorkflowRecoveryAuthority = async (
  decideWorkflowRecoveryAuthorityBody: DecideWorkflowRecoveryAuthorityBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<decideWorkflowRecoveryAuthorityResponse> => {
  return customFetch<decideWorkflowRecoveryAuthorityResponse>(
    getDecideWorkflowRecoveryAuthorityUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(decideWorkflowRecoveryAuthorityBody),
    },
  );
};

export const getDecideWorkflowRecoveryAuthorityQueryKey = (
  decideWorkflowRecoveryAuthorityBody?: DecideWorkflowRecoveryAuthorityBody,
) => {
  return [
    "POST",
    `/workflow-service/v1/recovery-authority/decisions`,
    decideWorkflowRecoveryAuthorityBody,
  ] as const;
};

export const getDecideWorkflowRecoveryAuthorityQueryOptions = <
  TData = Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>,
  TError = void,
>(
  decideWorkflowRecoveryAuthorityBody: DecideWorkflowRecoveryAuthorityBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDecideWorkflowRecoveryAuthorityQueryKey(decideWorkflowRecoveryAuthorityBody);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>> = ({
    signal,
  }) =>
    decideWorkflowRecoveryAuthority(decideWorkflowRecoveryAuthorityBody, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DecideWorkflowRecoveryAuthorityQueryResult = NonNullable<
  Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>
>;
export type DecideWorkflowRecoveryAuthorityQueryError = void;

export function useDecideWorkflowRecoveryAuthority<
  TData = Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>,
  TError = void,
>(
  decideWorkflowRecoveryAuthorityBody: DecideWorkflowRecoveryAuthorityBody,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>,
          TError,
          Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDecideWorkflowRecoveryAuthority<
  TData = Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>,
  TError = void,
>(
  decideWorkflowRecoveryAuthorityBody: DecideWorkflowRecoveryAuthorityBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>,
          TError,
          Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDecideWorkflowRecoveryAuthority<
  TData = Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>,
  TError = void,
>(
  decideWorkflowRecoveryAuthorityBody: DecideWorkflowRecoveryAuthorityBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Decide live recovery authority for a receiver command
 */

export function useDecideWorkflowRecoveryAuthority<
  TData = Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>,
  TError = void,
>(
  decideWorkflowRecoveryAuthorityBody: DecideWorkflowRecoveryAuthorityBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof decideWorkflowRecoveryAuthority>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDecideWorkflowRecoveryAuthorityQueryOptions(
    decideWorkflowRecoveryAuthorityBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type submitWorkflowRunResponse202 = {
  data: WorkflowRunSubmitResponse;
  status: 202;
};

export type submitWorkflowRunResponse400 = {
  data: void;
  status: 400;
};

export type submitWorkflowRunResponseSuccess = submitWorkflowRunResponse202 & {
  headers: Headers;
};
export type submitWorkflowRunResponseError = submitWorkflowRunResponse400 & {
  headers: Headers;
};

export type submitWorkflowRunResponse =
  | submitWorkflowRunResponseSuccess
  | submitWorkflowRunResponseError;

export const getSubmitWorkflowRunUrl = (definitionKey: string) => {
  return `/workflow-service/v1/workflows/${definitionKey}/runs`;
};

/**
 * @summary Submit a workflow run
 */
export const submitWorkflowRun = async (
  definitionKey: string,
  workflowRunSubmissionRequest: WorkflowRunSubmissionRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<submitWorkflowRunResponse> => {
  return customFetch<submitWorkflowRunResponse>(getSubmitWorkflowRunUrl(definitionKey), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(workflowRunSubmissionRequest),
  });
};

export const getSubmitWorkflowRunQueryKey = (
  definitionKey: string,
  workflowRunSubmissionRequest?: WorkflowRunSubmissionRequest,
) => {
  return [
    "POST",
    `/workflow-service/v1/workflows/${definitionKey}/runs`,
    workflowRunSubmissionRequest,
  ] as const;
};

export const getSubmitWorkflowRunQueryOptions = <
  TData = Awaited<ReturnType<typeof submitWorkflowRun>>,
  TError = void,
>(
  definitionKey: string,
  workflowRunSubmissionRequest: WorkflowRunSubmissionRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSubmitWorkflowRunQueryKey(definitionKey, workflowRunSubmissionRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof submitWorkflowRun>>> = ({ signal }) =>
    submitWorkflowRun(definitionKey, workflowRunSubmissionRequest, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: definitionKey !== null && definitionKey !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRun>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type SubmitWorkflowRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof submitWorkflowRun>>
>;
export type SubmitWorkflowRunQueryError = void;

export function useSubmitWorkflowRun<
  TData = Awaited<ReturnType<typeof submitWorkflowRun>>,
  TError = void,
>(
  definitionKey: string,
  workflowRunSubmissionRequest: WorkflowRunSubmissionRequest,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRun>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitWorkflowRun>>,
          TError,
          Awaited<ReturnType<typeof submitWorkflowRun>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSubmitWorkflowRun<
  TData = Awaited<ReturnType<typeof submitWorkflowRun>>,
  TError = void,
>(
  definitionKey: string,
  workflowRunSubmissionRequest: WorkflowRunSubmissionRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRun>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitWorkflowRun>>,
          TError,
          Awaited<ReturnType<typeof submitWorkflowRun>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSubmitWorkflowRun<
  TData = Awaited<ReturnType<typeof submitWorkflowRun>>,
  TError = void,
>(
  definitionKey: string,
  workflowRunSubmissionRequest: WorkflowRunSubmissionRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Submit a workflow run
 */

export function useSubmitWorkflowRun<
  TData = Awaited<ReturnType<typeof submitWorkflowRun>>,
  TError = void,
>(
  definitionKey: string,
  workflowRunSubmissionRequest: WorkflowRunSubmissionRequest,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSubmitWorkflowRunQueryOptions(
    definitionKey,
    workflowRunSubmissionRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listWorkflowRunsResponse200 = {
  data: ListWorkflowRuns200;
  status: 200;
};

export type listWorkflowRunsResponse400 = {
  data: void;
  status: 400;
};

export type listWorkflowRunsResponseSuccess = listWorkflowRunsResponse200 & {
  headers: Headers;
};
export type listWorkflowRunsResponseError = listWorkflowRunsResponse400 & {
  headers: Headers;
};

export type listWorkflowRunsResponse =
  | listWorkflowRunsResponseSuccess
  | listWorkflowRunsResponseError;

export const getListWorkflowRunsUrl = (params?: ListWorkflowRunsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/workflow-service/v1/workflow-runs?${stringifiedParams}`
    : `/workflow-service/v1/workflow-runs`;
};

/**
 * Returns workflow runs for the tenant. `stuck=true` is the operator attention queue.
 * @summary List workflow runs
 */
export const listWorkflowRuns = async (
  params?: ListWorkflowRunsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<listWorkflowRunsResponse> => {
  return customFetch<listWorkflowRunsResponse>(getListWorkflowRunsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListWorkflowRunsMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listWorkflowRuns>>,
    TError,
    { params?: ListWorkflowRunsParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listWorkflowRuns>>,
  TError,
  { params?: ListWorkflowRunsParams },
  TContext
> => {
  const mutationKey = ["listWorkflowRuns"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listWorkflowRuns>>,
    { params?: ListWorkflowRunsParams }
  > = (props) => {
    const { params } = props ?? {};

    return listWorkflowRuns(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListWorkflowRunsMutationResult = NonNullable<
  Awaited<ReturnType<typeof listWorkflowRuns>>
>;

export type ListWorkflowRunsMutationError = void;

/**
 * @summary List workflow runs
 */
export const useListWorkflowRuns = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof listWorkflowRuns>>,
      TError,
      { params?: ListWorkflowRunsParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof listWorkflowRuns>>,
  TError,
  { params?: ListWorkflowRunsParams },
  TContext
> => {
  return useMutation(getListWorkflowRunsMutationOptions(options), queryClient);
};
export type getWorkflowRunStatusResponse200 = {
  data: WorkflowRunStatusResponse;
  status: 200;
};

export type getWorkflowRunStatusResponse404 = {
  data: void;
  status: 404;
};

export type getWorkflowRunStatusResponseSuccess = getWorkflowRunStatusResponse200 & {
  headers: Headers;
};
export type getWorkflowRunStatusResponseError = getWorkflowRunStatusResponse404 & {
  headers: Headers;
};

export type getWorkflowRunStatusResponse =
  | getWorkflowRunStatusResponseSuccess
  | getWorkflowRunStatusResponseError;

export const getGetWorkflowRunStatusUrl = (runId: string) => {
  return `/workflow-service/v1/workflow-runs/${runId}`;
};

/**
 * @summary Get workflow run status
 */
export const getWorkflowRunStatus = async (
  runId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getWorkflowRunStatusResponse> => {
  return customFetch<getWorkflowRunStatusResponse>(getGetWorkflowRunStatusUrl(runId), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkflowRunStatusMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getWorkflowRunStatus>>,
    TError,
    { runId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getWorkflowRunStatus>>,
  TError,
  { runId: string },
  TContext
> => {
  const mutationKey = ["getWorkflowRunStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getWorkflowRunStatus>>,
    { runId: string }
  > = (props) => {
    const { runId } = props ?? {};

    return getWorkflowRunStatus(runId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetWorkflowRunStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof getWorkflowRunStatus>>
>;

export type GetWorkflowRunStatusMutationError = void;

/**
 * @summary Get workflow run status
 */
export const useGetWorkflowRunStatus = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getWorkflowRunStatus>>,
      TError,
      { runId: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getWorkflowRunStatus>>,
  TError,
  { runId: string },
  TContext
> => {
  return useMutation(getGetWorkflowRunStatusMutationOptions(options), queryClient);
};
export type getWorkflowRunActionLogResponse200 = {
  data: WorkflowRunActionLogResponse;
  status: 200;
};

export type getWorkflowRunActionLogResponse400 = {
  data: void;
  status: 400;
};

export type getWorkflowRunActionLogResponseSuccess = getWorkflowRunActionLogResponse200 & {
  headers: Headers;
};
export type getWorkflowRunActionLogResponseError = getWorkflowRunActionLogResponse400 & {
  headers: Headers;
};

export type getWorkflowRunActionLogResponse =
  | getWorkflowRunActionLogResponseSuccess
  | getWorkflowRunActionLogResponseError;

export const getGetWorkflowRunActionLogUrl = (runId: string) => {
  return `/workflow-service/v1/workflow-runs/${runId}/action-log`;
};

/**
 * Returns the engine-owned action-log journal for the run in append order
 * (`sequence` ascending). Empty when the run has no ledger (disabled mode,
 * non-durable, or legacy). Payload bodies are never included.
 * @summary List durable action-log events for a workflow run
 */
export const getWorkflowRunActionLog = async (
  runId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getWorkflowRunActionLogResponse> => {
  return customFetch<getWorkflowRunActionLogResponse>(getGetWorkflowRunActionLogUrl(runId), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkflowRunActionLogMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getWorkflowRunActionLog>>,
    TError,
    { runId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getWorkflowRunActionLog>>,
  TError,
  { runId: string },
  TContext
> => {
  const mutationKey = ["getWorkflowRunActionLog"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getWorkflowRunActionLog>>,
    { runId: string }
  > = (props) => {
    const { runId } = props ?? {};

    return getWorkflowRunActionLog(runId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetWorkflowRunActionLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof getWorkflowRunActionLog>>
>;

export type GetWorkflowRunActionLogMutationError = void;

/**
 * @summary List durable action-log events for a workflow run
 */
export const useGetWorkflowRunActionLog = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getWorkflowRunActionLog>>,
      TError,
      { runId: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getWorkflowRunActionLog>>,
  TError,
  { runId: string },
  TContext
> => {
  return useMutation(getGetWorkflowRunActionLogMutationOptions(options), queryClient);
};
export type getWorkflowRunCompensationScopesResponse200 = {
  data: WorkflowRunCompensationScopesResponse;
  status: 200;
};

export type getWorkflowRunCompensationScopesResponse400 = {
  data: void;
  status: 400;
};

export type getWorkflowRunCompensationScopesResponse401 = {
  data: void;
  status: 401;
};

export type getWorkflowRunCompensationScopesResponse403 = {
  data: void;
  status: 403;
};

export type getWorkflowRunCompensationScopesResponse404 = {
  data: void;
  status: 404;
};

export type getWorkflowRunCompensationScopesResponse429 = {
  data: void;
  status: 429;
};

export type getWorkflowRunCompensationScopesResponse503 = {
  data: void;
  status: 503;
};

export type getWorkflowRunCompensationScopesResponseSuccess =
  getWorkflowRunCompensationScopesResponse200 & {
    headers: Headers;
  };
export type getWorkflowRunCompensationScopesResponseError = (
  | getWorkflowRunCompensationScopesResponse400
  | getWorkflowRunCompensationScopesResponse401
  | getWorkflowRunCompensationScopesResponse403
  | getWorkflowRunCompensationScopesResponse404
  | getWorkflowRunCompensationScopesResponse429
  | getWorkflowRunCompensationScopesResponse503
) & {
  headers: Headers;
};

export type getWorkflowRunCompensationScopesResponse =
  | getWorkflowRunCompensationScopesResponseSuccess
  | getWorkflowRunCompensationScopesResponseError;

export const getGetWorkflowRunCompensationScopesUrl = (
  runId: string,
  params?: GetWorkflowRunCompensationScopesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/workflow-service/v1/workflow-runs/${runId}/compensation-scopes?${stringifiedParams}`
    : `/workflow-service/v1/workflow-runs/${runId}/compensation-scopes`;
};

/**
 * Returns bounded authoritative scope history for an authorised tenant-owned run.
 * @summary List workflow scoped compensation history
 */
export const getWorkflowRunCompensationScopes = async (
  runId: string,
  params?: GetWorkflowRunCompensationScopesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getWorkflowRunCompensationScopesResponse> => {
  return customFetch<getWorkflowRunCompensationScopesResponse>(
    getGetWorkflowRunCompensationScopesUrl(runId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWorkflowRunCompensationScopesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getWorkflowRunCompensationScopes>>,
    TError,
    { runId: string; params?: GetWorkflowRunCompensationScopesParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getWorkflowRunCompensationScopes>>,
  TError,
  { runId: string; params?: GetWorkflowRunCompensationScopesParams },
  TContext
> => {
  const mutationKey = ["getWorkflowRunCompensationScopes"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getWorkflowRunCompensationScopes>>,
    { runId: string; params?: GetWorkflowRunCompensationScopesParams }
  > = (props) => {
    const { runId, params } = props ?? {};

    return getWorkflowRunCompensationScopes(runId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetWorkflowRunCompensationScopesMutationResult = NonNullable<
  Awaited<ReturnType<typeof getWorkflowRunCompensationScopes>>
>;

export type GetWorkflowRunCompensationScopesMutationError = void;

/**
 * @summary List workflow scoped compensation history
 */
export const useGetWorkflowRunCompensationScopes = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getWorkflowRunCompensationScopes>>,
      TError,
      { runId: string; params?: GetWorkflowRunCompensationScopesParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getWorkflowRunCompensationScopes>>,
  TError,
  { runId: string; params?: GetWorkflowRunCompensationScopesParams },
  TContext
> => {
  return useMutation(getGetWorkflowRunCompensationScopesMutationOptions(options), queryClient);
};
export type submitWorkflowRunScopedCompensationCommandResponse202 = {
  data: WorkflowRunScopedCompensationCommandResponse;
  status: 202;
};

export type submitWorkflowRunScopedCompensationCommandResponse400 = {
  data: void;
  status: 400;
};

export type submitWorkflowRunScopedCompensationCommandResponse401 = {
  data: void;
  status: 401;
};

export type submitWorkflowRunScopedCompensationCommandResponse403 = {
  data: void;
  status: 403;
};

export type submitWorkflowRunScopedCompensationCommandResponse404 = {
  data: void;
  status: 404;
};

export type submitWorkflowRunScopedCompensationCommandResponse409 = {
  data: void;
  status: 409;
};

export type submitWorkflowRunScopedCompensationCommandResponse413 = {
  data: void;
  status: 413;
};

export type submitWorkflowRunScopedCompensationCommandResponse422 = {
  data: void;
  status: 422;
};

export type submitWorkflowRunScopedCompensationCommandResponse429 = {
  data: void;
  status: 429;
};

export type submitWorkflowRunScopedCompensationCommandResponse503 = {
  data: void;
  status: 503;
};

export type submitWorkflowRunScopedCompensationCommandResponseSuccess =
  submitWorkflowRunScopedCompensationCommandResponse202 & {
    headers: Headers;
  };
export type submitWorkflowRunScopedCompensationCommandResponseError = (
  | submitWorkflowRunScopedCompensationCommandResponse400
  | submitWorkflowRunScopedCompensationCommandResponse401
  | submitWorkflowRunScopedCompensationCommandResponse403
  | submitWorkflowRunScopedCompensationCommandResponse404
  | submitWorkflowRunScopedCompensationCommandResponse409
  | submitWorkflowRunScopedCompensationCommandResponse413
  | submitWorkflowRunScopedCompensationCommandResponse422
  | submitWorkflowRunScopedCompensationCommandResponse429
  | submitWorkflowRunScopedCompensationCommandResponse503
) & {
  headers: Headers;
};

export type submitWorkflowRunScopedCompensationCommandResponse =
  | submitWorkflowRunScopedCompensationCommandResponseSuccess
  | submitWorkflowRunScopedCompensationCommandResponseError;

export const getSubmitWorkflowRunScopedCompensationCommandUrl = (runId: string) => {
  return `/workflow-service/v1/workflow-runs/${runId}/compensation-scopes/commands`;
};

/**
 * Accepts an authorised, durable operator recovery command targeting a blocked scope occurrence attempt.
 * @summary Submit scoped recovery command for a workflow run
 */
export const submitWorkflowRunScopedCompensationCommand = async (
  runId: string,
  workflowRunScopedCompensationCommandRequest: WorkflowRunScopedCompensationCommandRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<submitWorkflowRunScopedCompensationCommandResponse> => {
  return customFetch<submitWorkflowRunScopedCompensationCommandResponse>(
    getSubmitWorkflowRunScopedCompensationCommandUrl(runId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(workflowRunScopedCompensationCommandRequest),
    },
  );
};

export const getSubmitWorkflowRunScopedCompensationCommandQueryKey = (
  runId: string,
  workflowRunScopedCompensationCommandRequest?: WorkflowRunScopedCompensationCommandRequest,
) => {
  return [
    "POST",
    `/workflow-service/v1/workflow-runs/${runId}/compensation-scopes/commands`,
    workflowRunScopedCompensationCommandRequest,
  ] as const;
};

export const getSubmitWorkflowRunScopedCompensationCommandQueryOptions = <
  TData = Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
  TError = void,
>(
  runId: string,
  workflowRunScopedCompensationCommandRequest: WorkflowRunScopedCompensationCommandRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSubmitWorkflowRunScopedCompensationCommandQueryKey(
      runId,
      workflowRunScopedCompensationCommandRequest,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>
  > = ({ signal }) =>
    submitWorkflowRunScopedCompensationCommand(runId, workflowRunScopedCompensationCommandRequest, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: runId !== null && runId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SubmitWorkflowRunScopedCompensationCommandQueryResult = NonNullable<
  Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>
>;
export type SubmitWorkflowRunScopedCompensationCommandQueryError = void;

export function useSubmitWorkflowRunScopedCompensationCommand<
  TData = Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
  TError = void,
>(
  runId: string,
  workflowRunScopedCompensationCommandRequest: WorkflowRunScopedCompensationCommandRequest,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
          TError,
          Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSubmitWorkflowRunScopedCompensationCommand<
  TData = Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
  TError = void,
>(
  runId: string,
  workflowRunScopedCompensationCommandRequest: WorkflowRunScopedCompensationCommandRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
          TError,
          Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSubmitWorkflowRunScopedCompensationCommand<
  TData = Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
  TError = void,
>(
  runId: string,
  workflowRunScopedCompensationCommandRequest: WorkflowRunScopedCompensationCommandRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Submit scoped recovery command for a workflow run
 */

export function useSubmitWorkflowRunScopedCompensationCommand<
  TData = Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
  TError = void,
>(
  runId: string,
  workflowRunScopedCompensationCommandRequest: WorkflowRunScopedCompensationCommandRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof submitWorkflowRunScopedCompensationCommand>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSubmitWorkflowRunScopedCompensationCommandQueryOptions(
    runId,
    workflowRunScopedCompensationCommandRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type resumeWorkflowRunResponse202 = {
  data: WorkflowRunStatusResponse;
  status: 202;
};

export type resumeWorkflowRunResponse400 = {
  data: void;
  status: 400;
};

export type resumeWorkflowRunResponse404 = {
  data: void;
  status: 404;
};

export type resumeWorkflowRunResponse409 = {
  data: void;
  status: 409;
};

export type resumeWorkflowRunResponseSuccess = resumeWorkflowRunResponse202 & {
  headers: Headers;
};
export type resumeWorkflowRunResponseError = (
  | resumeWorkflowRunResponse400
  | resumeWorkflowRunResponse404
  | resumeWorkflowRunResponse409
) & {
  headers: Headers;
};

export type resumeWorkflowRunResponse =
  | resumeWorkflowRunResponseSuccess
  | resumeWorkflowRunResponseError;

export const getResumeWorkflowRunUrl = (runId: string) => {
  return `/workflow-service/v1/workflow-runs/${runId}/resume`;
};

/**
 * @summary Resume a workflow run
 */
export const resumeWorkflowRun = async (
  runId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<resumeWorkflowRunResponse> => {
  return customFetch<resumeWorkflowRunResponse>(getResumeWorkflowRunUrl(runId), {
    ...options,
    method: "POST",
  });
};

export const getResumeWorkflowRunQueryKey = (runId: string) => {
  return ["POST", `/workflow-service/v1/workflow-runs/${runId}/resume`] as const;
};

export const getResumeWorkflowRunQueryOptions = <
  TData = Awaited<ReturnType<typeof resumeWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resumeWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getResumeWorkflowRunQueryKey(runId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof resumeWorkflowRun>>> = ({ signal }) =>
    resumeWorkflowRun(runId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: runId !== null && runId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof resumeWorkflowRun>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ResumeWorkflowRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof resumeWorkflowRun>>
>;
export type ResumeWorkflowRunQueryError = void;

export function useResumeWorkflowRun<
  TData = Awaited<ReturnType<typeof resumeWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof resumeWorkflowRun>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resumeWorkflowRun>>,
          TError,
          Awaited<ReturnType<typeof resumeWorkflowRun>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useResumeWorkflowRun<
  TData = Awaited<ReturnType<typeof resumeWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resumeWorkflowRun>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resumeWorkflowRun>>,
          TError,
          Awaited<ReturnType<typeof resumeWorkflowRun>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useResumeWorkflowRun<
  TData = Awaited<ReturnType<typeof resumeWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resumeWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resume a workflow run
 */

export function useResumeWorkflowRun<
  TData = Awaited<ReturnType<typeof resumeWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof resumeWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getResumeWorkflowRunQueryOptions(runId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type cancelWorkflowRunResponse202 = {
  data: WorkflowRunStatusResponse;
  status: 202;
};

export type cancelWorkflowRunResponse404 = {
  data: void;
  status: 404;
};

export type cancelWorkflowRunResponseSuccess = cancelWorkflowRunResponse202 & {
  headers: Headers;
};
export type cancelWorkflowRunResponseError = cancelWorkflowRunResponse404 & {
  headers: Headers;
};

export type cancelWorkflowRunResponse =
  | cancelWorkflowRunResponseSuccess
  | cancelWorkflowRunResponseError;

export const getCancelWorkflowRunUrl = (runId: string) => {
  return `/workflow-service/v1/workflow-runs/${runId}/cancel`;
};

/**
 * @summary Cancel a workflow run
 */
export const cancelWorkflowRun = async (
  runId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<cancelWorkflowRunResponse> => {
  return customFetch<cancelWorkflowRunResponse>(getCancelWorkflowRunUrl(runId), {
    ...options,
    method: "POST",
  });
};

export const getCancelWorkflowRunQueryKey = (runId: string) => {
  return ["POST", `/workflow-service/v1/workflow-runs/${runId}/cancel`] as const;
};

export const getCancelWorkflowRunQueryOptions = <
  TData = Awaited<ReturnType<typeof cancelWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cancelWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCancelWorkflowRunQueryKey(runId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof cancelWorkflowRun>>> = ({ signal }) =>
    cancelWorkflowRun(runId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: runId !== null && runId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof cancelWorkflowRun>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type CancelWorkflowRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof cancelWorkflowRun>>
>;
export type CancelWorkflowRunQueryError = void;

export function useCancelWorkflowRun<
  TData = Awaited<ReturnType<typeof cancelWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof cancelWorkflowRun>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cancelWorkflowRun>>,
          TError,
          Awaited<ReturnType<typeof cancelWorkflowRun>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCancelWorkflowRun<
  TData = Awaited<ReturnType<typeof cancelWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cancelWorkflowRun>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cancelWorkflowRun>>,
          TError,
          Awaited<ReturnType<typeof cancelWorkflowRun>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCancelWorkflowRun<
  TData = Awaited<ReturnType<typeof cancelWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cancelWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Cancel a workflow run
 */

export function useCancelWorkflowRun<
  TData = Awaited<ReturnType<typeof cancelWorkflowRun>>,
  TError = void,
>(
  runId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cancelWorkflowRun>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCancelWorkflowRunQueryOptions(runId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getWorkflowRunRecoveryResponse200 = {
  data: WorkflowRunRecoveryResponse;
  status: 200;
};

export type getWorkflowRunRecoveryResponse400 = {
  data: void;
  status: 400;
};

export type getWorkflowRunRecoveryResponse401 = {
  data: void;
  status: 401;
};

export type getWorkflowRunRecoveryResponse403 = {
  data: void;
  status: 403;
};

export type getWorkflowRunRecoveryResponse404 = {
  data: void;
  status: 404;
};

export type getWorkflowRunRecoveryResponseSuccess = getWorkflowRunRecoveryResponse200 & {
  headers: Headers;
};
export type getWorkflowRunRecoveryResponseError = (
  | getWorkflowRunRecoveryResponse400
  | getWorkflowRunRecoveryResponse401
  | getWorkflowRunRecoveryResponse403
  | getWorkflowRunRecoveryResponse404
) & {
  headers: Headers;
};

export type getWorkflowRunRecoveryResponse =
  | getWorkflowRunRecoveryResponseSuccess
  | getWorkflowRunRecoveryResponseError;

export const getGetWorkflowRunRecoveryUrl = (
  runId: string,
  params?: GetWorkflowRunRecoveryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/workflow-service/v1/workflow-runs/${runId}/recovery?${stringifiedParams}`
    : `/workflow-service/v1/workflow-runs/${runId}/recovery`;
};

/**
 * @summary Inspect workflow run recovery state
 */
export const getWorkflowRunRecovery = async (
  runId: string,
  params?: GetWorkflowRunRecoveryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getWorkflowRunRecoveryResponse> => {
  return customFetch<getWorkflowRunRecoveryResponse>(getGetWorkflowRunRecoveryUrl(runId, params), {
    ...options,
    method: "GET",
  });
};

export const getGetWorkflowRunRecoveryMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getWorkflowRunRecovery>>,
    TError,
    { runId: string; params?: GetWorkflowRunRecoveryParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getWorkflowRunRecovery>>,
  TError,
  { runId: string; params?: GetWorkflowRunRecoveryParams },
  TContext
> => {
  const mutationKey = ["getWorkflowRunRecovery"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getWorkflowRunRecovery>>,
    { runId: string; params?: GetWorkflowRunRecoveryParams }
  > = (props) => {
    const { runId, params } = props ?? {};

    return getWorkflowRunRecovery(runId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetWorkflowRunRecoveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof getWorkflowRunRecovery>>
>;

export type GetWorkflowRunRecoveryMutationError = void;

/**
 * @summary Inspect workflow run recovery state
 */
export const useGetWorkflowRunRecovery = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getWorkflowRunRecovery>>,
      TError,
      { runId: string; params?: GetWorkflowRunRecoveryParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getWorkflowRunRecovery>>,
  TError,
  { runId: string; params?: GetWorkflowRunRecoveryParams },
  TContext
> => {
  return useMutation(getGetWorkflowRunRecoveryMutationOptions(options), queryClient);
};
export type submitWorkflowRunRecoveryCommandResponse202 = {
  data: void;
  status: 202;
};

export type submitWorkflowRunRecoveryCommandResponse400 = {
  data: void;
  status: 400;
};

export type submitWorkflowRunRecoveryCommandResponse401 = {
  data: void;
  status: 401;
};

export type submitWorkflowRunRecoveryCommandResponse403 = {
  data: void;
  status: 403;
};

export type submitWorkflowRunRecoveryCommandResponse404 = {
  data: void;
  status: 404;
};

export type submitWorkflowRunRecoveryCommandResponse409 = {
  data: void;
  status: 409;
};

export type submitWorkflowRunRecoveryCommandResponse503 = {
  data: void;
  status: 503;
};

export type submitWorkflowRunRecoveryCommandResponseSuccess =
  submitWorkflowRunRecoveryCommandResponse202 & {
    headers: Headers;
  };
export type submitWorkflowRunRecoveryCommandResponseError = (
  | submitWorkflowRunRecoveryCommandResponse400
  | submitWorkflowRunRecoveryCommandResponse401
  | submitWorkflowRunRecoveryCommandResponse403
  | submitWorkflowRunRecoveryCommandResponse404
  | submitWorkflowRunRecoveryCommandResponse409
  | submitWorkflowRunRecoveryCommandResponse503
) & {
  headers: Headers;
};

export type submitWorkflowRunRecoveryCommandResponse =
  | submitWorkflowRunRecoveryCommandResponseSuccess
  | submitWorkflowRunRecoveryCommandResponseError;

export const getSubmitWorkflowRunRecoveryCommandUrl = (runId: string) => {
  return `/workflow-service/v1/workflow-runs/${runId}/recovery/commands`;
};

/**
 * @summary Submit recovery command for a workflow run
 */
export const submitWorkflowRunRecoveryCommand = async (
  runId: string,
  submitWorkflowRunRecoveryCommandBody: SubmitWorkflowRunRecoveryCommandBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<submitWorkflowRunRecoveryCommandResponse> => {
  return customFetch<submitWorkflowRunRecoveryCommandResponse>(
    getSubmitWorkflowRunRecoveryCommandUrl(runId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(submitWorkflowRunRecoveryCommandBody),
    },
  );
};

export const getSubmitWorkflowRunRecoveryCommandQueryKey = (
  runId: string,
  submitWorkflowRunRecoveryCommandBody?: SubmitWorkflowRunRecoveryCommandBody,
) => {
  return [
    "POST",
    `/workflow-service/v1/workflow-runs/${runId}/recovery/commands`,
    submitWorkflowRunRecoveryCommandBody,
  ] as const;
};

export const getSubmitWorkflowRunRecoveryCommandQueryOptions = <
  TData = Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>,
  TError = void,
>(
  runId: string,
  submitWorkflowRunRecoveryCommandBody: SubmitWorkflowRunRecoveryCommandBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSubmitWorkflowRunRecoveryCommandQueryKey(runId, submitWorkflowRunRecoveryCommandBody);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>> = ({
    signal,
  }) =>
    submitWorkflowRunRecoveryCommand(runId, submitWorkflowRunRecoveryCommandBody, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: runId !== null && runId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SubmitWorkflowRunRecoveryCommandQueryResult = NonNullable<
  Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>
>;
export type SubmitWorkflowRunRecoveryCommandQueryError = void;

export function useSubmitWorkflowRunRecoveryCommand<
  TData = Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>,
  TError = void,
>(
  runId: string,
  submitWorkflowRunRecoveryCommandBody: SubmitWorkflowRunRecoveryCommandBody,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>,
          TError,
          Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSubmitWorkflowRunRecoveryCommand<
  TData = Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>,
  TError = void,
>(
  runId: string,
  submitWorkflowRunRecoveryCommandBody: SubmitWorkflowRunRecoveryCommandBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>,
          TError,
          Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSubmitWorkflowRunRecoveryCommand<
  TData = Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>,
  TError = void,
>(
  runId: string,
  submitWorkflowRunRecoveryCommandBody: SubmitWorkflowRunRecoveryCommandBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Submit recovery command for a workflow run
 */

export function useSubmitWorkflowRunRecoveryCommand<
  TData = Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>,
  TError = void,
>(
  runId: string,
  submitWorkflowRunRecoveryCommandBody: SubmitWorkflowRunRecoveryCommandBody,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof submitWorkflowRunRecoveryCommand>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSubmitWorkflowRunRecoveryCommandQueryOptions(
    runId,
    submitWorkflowRunRecoveryCommandBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
